div.fdi.wc.multi-input-container {
  display: flex;
  flex-direction: column;
  border: solid 1px rgb(209 213 219);
  padding: 0.25rem;
  justify-content: center;

  div.input-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    column-gap: 0.25rem;
  }

  button.add-button {
    align-items: center;
    padding: 7px;
    border: solid 1px rgb(209 213 219);
  }

  button.delete-button {
    align-items: center;
    padding: 7px;
    border: solid 1px rgb(209 213 219);
  }
}